export const tosLink = 'https://www.kota.io/terms-of-service';
export const privacyLink = 'https://www.kota.io/privacy-policy';

export const feesAndChargesLink = 'https://www.kota.io/regulatory/schedule-of-fees-and-charges';
export const howMuchDoesItCostLink = 'https://help.kota.io/en/articles/6320770-how-much-does-kota-cost';

export const termsOfBusinessUKLink = 'https://www.kota.io/regulatory/uk-terms-of-business';
export const termsOfBusinessEULink = 'https://www.kota.io/regulatory/eu-terms-of-business';

export const empowerLifestyleStrategyLink =
  'https://yonder-011c6fce26c3.intercom-attachments-1.com/i/o/674400933/0528a60dac50738b0b73b819/10+Personal+Lifestyle+Strategy+for+DC.pdf?expires=1731510000&signature=75388646ab1613f2b0042145670a2638030302118e870100d965e733d0555e46&req=cicjEsl%2BlIJcFb4X1HO4gZQhkYG6RUwZ0an8c724ZuA5V1m5v9gM%2B%2BJxkZk5%250A';

export const demoBookedLink = 'https://www.kota.io/demo-booked';

export const minEmployeeAge = 18;

export const defaultErrorTitle = `Sorry, this shouldn't have happened`;
export const defaultErrorMessage = 'We are working to fix this issue. Please try again later.';
export const defaultErrorStatus = 500;
